import { type ComponentType, type ReactNode } from 'react'
import { styled } from '@mui/material/styles'

export const ActiveIntegrationsWrapper: ComponentType<{ children: ReactNode}> = styled( 'div' )( ( { theme } ) => ( {
	marginBottom: theme.spacing( 6 ),

	hr: {
		marginBottom: theme.spacing( 2 ),
	},
} ) )

export const ActiveIntegrationsEmptyStateWrapper: ComponentType<{ children: ReactNode}> = styled( 'div' )( ( { theme } ) => ( {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: theme.spacing( 4 ),
} ) )
